/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import "../charger_mgmt/EnergyCard.css";
import MDButton from "components/MDButton";
import Divider from "@mui/material/Divider";
import {
  Card,
  IconButton,
  ListItemIcon,
  Menu,
  Typography,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import { useState, useEffect, useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import Tooltip from "@mui/material/Tooltip";
import { useMaterialUIController, setMiniSidenav } from "context";
import { useNavigate } from "react-router-dom";
import { Tag } from "antd";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PopAddUser from "./PopAddUser";
import LaunchIcon from "@mui/icons-material/Launch";
import DeleteIcon from "@mui/icons-material/Delete";
import Loader from "components/custom/Loader";
import { useSnackbar } from "notistack";
import useApiRequest from "utils/Apirequest";
import EditIcon from "@mui/icons-material/Edit";
import { MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { capitalizeFirstLetterSafe } from "utils";
import { AutoTooltip } from "utils/Constant";
import { getDecodedUserData } from "utils/Constant";
import BulkUploadDialog from "components/BulkUpload/BulkUploadDialog";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CustomMaterialTablePage from "../../components/custom/CustomMaterialTablePage";
import Reset_pass_icon from "../../assets/cms-icons/resetPsw.png";
import Assign_driver_url from "../../assets/cms-icons/image (2).png";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import GetAppIcon from '@mui/icons-material/GetApp';

function Driver_mgmt() {
  const [controller, dispatch] = useMaterialUIController();
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  const [sorting, setSorting] = useState([]);
  const [page, setPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [dataRec, setDataRec] = useState([]);
  const [vehicleCounts, setVehicleCounts] = useState({
    "2-Wheeler": 0,
    "3-Wheeler": 0,
    "4-Wheeler": 0,
  });

  const [drivers, setDrivers] = useState([]);

  const { darkMode } = controller;
  const { sidenavColor } = controller;
  const { enqueueSnackbar } = useSnackbar();
  const apiRequest = useApiRequest();

  const statusList = ["active", "inactive"];
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);

  const [activeDrivers, setActiveDrivers] = useState(0);
  const [inactiveDrivers, setInactiveDrivers] = useState(0);
  const [totalDriversCount, setTotalDriversCount] = useState(0);
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const [columnFilters, setColumnFilters] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({
    make: false,
    model: false,
    gender: false,
    dob: false,
    role: false,
    email: false,
    battery_capacity: false,
    type: false,
    variant: false,
    vehicle_img: false,
  });

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 1000);

    return () => clearTimeout(delayDebounce);
  }, [searchText]);

  const handleSortingChange = (newSorting) => {
    setSorting(newSorting);
  };

  const totalVehicles =
    (vehicleCounts["2-Wheeler"] || 0) +
    (vehicleCounts["3-Wheeler"] || 0) +
    (vehicleCounts["4-Wheeler"] || 0);

  const getValues = () => {
    return {
      first_name: "",
      last_name: "",
      phone_number: "",
      rfidTag: "",
      password: "",
      email: "",
      gender: "",
      date_of_birth: "",
      state: "",
      city: "",
      type: "",
      make: "",
      model: "",
      variant: "",
      registeration_number: "",
      range: "",
      vehicle_img: "",
    };
  };

  const fetchFullDriverList = async () => {
    const { data } =
      (await apiRequest(
        "get",
        `users/user/get/pagination?role=Driver&page=1&limit=100000`,
        null,
        {},
        {},
        false
      )) || {};

    if (data?.success === true) {
      const drivers = data.data;
      setDrivers(drivers);

      // Normalize status & count
      const active = drivers.filter(
        (d) => d.status?.toString().toLowerCase() === "active"
      ).length;

      const inactive = drivers.filter(
        (d) => d.status?.toString().toLowerCase() === "inactive"
      ).length;

      setActiveDrivers(active);
      setInactiveDrivers(inactive);
      setTotalDriversCount(active + inactive);

    }
  };

  const handleDownloadDriversExcel = async () => {
    try {
      const { data } = (await apiRequest(
        "get",
        `users/user/get/pagination?role=Driver&page=1&limit=100000`,
        null,
        {},
        {},
        false
      )) || {};
  
      if (!data?.success || !data?.data?.length) {
        console.error("No driver data available!");
        return;
      }
  
      const drivers = data.data;
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Drivers");
  
  
      const headers = [
        "First Name",
        "Last Name",
        "Status",
        "Role",
        "Email",
        "Phone Number",
        "Date of Birth",
        "Gender",
        "Driver ID",     
        "Vehicle Reg",
        "Make",
        "Model",
        "Variant",
        "Type",
        "Battery Capacity (kWh)",
        "Range (km)",
        "VIN",
      ];
  
      const headerRow = sheet.addRow(headers);
  
      headerRow.font = { bold: true };
      headerRow.alignment = { horizontal: "center" };
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE082" },
        };
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      });
  
   
      drivers.forEach((driver) => {
        const vehicle = driver.user_vehicle?.[0] || {};
  
        const row = sheet.addRow([
          driver.firstName ?? "",
          driver.lastName ?? "",
          driver.status ?? "",
          driver.role ?? "",
          driver.email ?? "",
          driver.phoneNumber ?? "",
          driver.dob ?? "",
          driver.gender ?? "",
          driver.rfidTag ?? "",  
          vehicle.vehicle_reg ?? "",
          vehicle.make ?? "",
          vehicle.model ?? "",
          vehicle.variant ?? "",
          vehicle.type ?? "",
          vehicle.battery_capacity ?? "",
          vehicle.range ?? "",
          vehicle.vin ?? "",
        ]);
  
        row.eachCell((cell) => {
          cell.alignment = { horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });
  
      sheet.columns.forEach((col) => (col.width = 22));
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      saveAs(blob, `Drivers_list.xlsx`);
    } catch (error) {
      console.error("Failed to download drivers Excel:", error);
    }
  };



  useEffect(() => {
    setPage(pagination.pageIndex);
    setPageSize(pagination.pageSize);
  }, [pagination]);

  useEffect(() => {
    fetchFullDriverList();
  }, []);

  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }


    (async () => {
      const { data } =
        (await apiRequest(
          "get",
          `users/user/get/pagination?role=Driver&page=${page + 1
          }&limit=${pageSize}&search=${searchText}&sortField=${sorting[0]?.id || ""
          }&sortOrder=${sorting[0]?.desc ? "desc" : "asc"}`,
          null,
          {},
          {},
          false
        )) || {};

      if (data?.success === true) {
        const drivers = data.data;

        setDataRec(drivers);
        setTotalRows(data?.pagination?.totalRecords);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    })();
  }, [page, pageSize, searchText]);

  const handleToggleDriverStatus = async (rowData) => {
    const isCurrentlyActive = rowData?.status === "active";

    const payload = {
      status: isCurrentlyActive ? "Inactive" : "active",
    };

    try {
      const { data } =
        (await apiRequest(
          "PATCH",
          `users/user/${rowData.phoneNumber}/status`,
          payload,
          {},
          {}
        )) || {};

      if (data?.status || data?.success) {
        setDataRec((prev) =>
          prev.map((row) =>
            row.phoneNumber === rowData.phoneNumber
              ? { ...row, status: payload.status }
              : row
          )
        );
      }
    } catch (err) {
      console.error("Failed to update driver status", err);
    }
  };

  const handleSearchChange = (value) => {
    const searchValue =
      typeof value === "string"
        ? value
        : value?.target?.value ?? "";

    setSearchText(searchValue);
    setPage(0);
  };

  const [isDisabled, setIsDisabled] = useState(false);
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState(getValues);

  const handleViewDriver = (row_data) => {
    if (window.innerWidth < 1200) {
      setMiniSidenav(dispatch, true);
    }
    navigate("/Driver-Management/view-driver", { state: row_data });
  };
  const handleAssignDriver = (row_data) => {
    if (window.innerWidth < 1200) {
      setMiniSidenav(dispatch, true);
    }
    navigate("/Driver-Management/Assign-Driver", { state: row_data });
  };
  const handleEdit = (row_data) => {
    if (window.innerWidth < 1200) {
      setMiniSidenav(dispatch, true);
    }
    navigate("/Update-Driver", { state: row_data });
  };
  const ResetPassword = (row_data) => {
    navigate("/Driver-Password", { state: row_data });
  };
  const handleDelete = async (row_data) => {
    if (row_data.status === "Inactive") {
      return enqueueSnackbar("An inactive account cannot be deleted again.", {
        variant: "error",
      });
    }

    const { data } =
      (await apiRequest(
        "delete",
        "users/user/" + row_data.phoneNumber,
        null,
        {},
        {
          "Content-Type": "application/json",
        }
      )) || {};

    if (data.success === true) {
      window.location.reload();
    }
  };
  const column = [
    {
      header: "Driver Id",
      accessorKey: "rfidTag",
      align: "center",
      muiTableHeadCellProps: {
        align: "left",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
      Cell: ({ row }) => {
        const driverId = row?.original?.rfidTag;

        return (
          <AutoTooltip maxWidth={150}>
            <span
              onClick={(e) => handleViewDriver(row?.original)}
              style={{
                color: "#1E88E5",
                cursor: "pointer",
                textDecoration: "underline",
                marginLeft: "10px",
              }}
            >
              {driverId}
            </span>
          </AutoTooltip>
        );
      },
    },
    {
      header: "Full Name",
      accessorFn: (row) =>
        `${row.firstName || ""} ${row.lastName || ""}`.trim(),
      id: "fullName",
      filterVariant: "text",
      enableColumnFilter: true,

      Cell: ({ row }) => {
        const { firstName, lastName } = row.original;
        return (
          <AutoTooltip maxWidth={150}>
            {`${firstName || ""} ${lastName || ""}`}
          </AutoTooltip>
        );
      },
    },
    {
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },

      header: "Status",
      accessorKey: "status",
      filterVariant: "select",
      filterSelectOptions: statusList,
      muiTableHeadCellFilterTextFieldProps: {
        sx: {
          textTransform: "none",
          "& .MuiInputLabel-root": {
            textTransform: "none",
          },
        },
      },
      align: "center",
      fixed: "true",

      Cell: ({ row }) => {
        const status = row.original.status;
        const statusColors = {
          active: "green",
          inactive: "red",
        };

        const color = statusColors[status] || "red";

        return (
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="md"
            style={{ flex: 1 }}
          >
            <Tag color={color}>{capitalizeFirstLetterSafe(status)}</Tag>
          </MDBox>
        );
      },
    },

    {
      header: "Phone Number",
      id: "phoneNumber",
      accessorKey: "phoneNumber",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },

    {
      header: "Vehicle ID",
      id: "vehicle_reg",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorFn: (row) =>
        row.user_vehicle?.map(v => v.vehicle_reg).join(", ") || "",
      filterVariant: "text",
      enableColumnFilter: true,

      Cell: ({ row }) => (
        <div>
          {row.original.user_vehicle.map((vehicle, index) => (
            <AutoTooltip key={index} maxWidth={100}>
              <div>{vehicle.vehicle_reg || "-"}</div>
            </AutoTooltip>
          ))}
        </div>
      ),
    },
    {
      header: "VIN",
      filterVariant: "text",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorFn: (row) =>
        row.user_vehicle?.map(v => v.vin).join(", ") || "",
      enableColumnFilter: true,
      Cell: (row) => (
        <div>
          {row.row.original.user_vehicle.map((vehicle, index) => (
            <AutoTooltip maxWidth={100}>
              <div key={index}>{vehicle?.vin || "-"}</div>
            </AutoTooltip>
          ))}
        </div>
      ),
    },
    {
      header: "VID",
      filterVariant: "text",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorFn: (row) =>
        row.user_vehicle?.map(v => v.vid).join(", ") || "",
      enableColumnFilter: true,
      Cell: (row) => (
        <div>
          {row.row.original.user_vehicle.map((vehicle, index) => (
            <AutoTooltip maxWidth={100}>
              <div key={index}>{vehicle?.vid || "-"}</div>
            </AutoTooltip>
          ))}
        </div>
      ),
    },
    {
      header: "Gender",
      id: "gender",
      accessorKey: "gender",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      header: "DOB",
      id: "dob",
      accessorKey: "dob",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      header: "Role",
      id: "role",
      accessorKey: "role",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      header: "Email",
      id: "email",
      accessorKey: "email",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },

    {
      header: "Type",
      id: "type",
      filterVariant: "text",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: (row) => (
        <div>
          {row.row.original.user_vehicle.map((vehicle, index) => (
            <AutoTooltip maxWidth={100}>
              <div key={index}>{vehicle.type || "-"}</div>
            </AutoTooltip>
          ))}
        </div>
      ),
    },
    {
      header: "Battery Capacity",
      id: "battery_capacity",
      filterVariant: "text",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: (row) => (
        <div>
          {row.row.original.user_vehicle.map((vehicle, index) => (
            <AutoTooltip maxWidth={100}>
              <div key={index}>
                {vehicle.battery_capacity
                  ? `${vehicle.battery_capacity} kWh`
                  : "N/A"}
              </div>
            </AutoTooltip>
          ))}
        </div>
      ),
    },
    // {
    //   header: "Vehicle Image",
    //   id: "vehicle_img",
    //   filterVariant: "text",
    //   align: "center",
    //   muiTableHeadCellProps: {
    //     align: "center",
    //   },
    //   muiTableBodyCellProps: {
    //     align: "center",
    //   },
    //   Cell: (row) => (
    //     <div>
    //       {row.row.original.user_vehicle.map((vehicle, index) => (
    //         <div key={index}>
    //           {vehicle.vehicle_img ? (
    //             <img
    //               src={vehicle.vehicle_img}
    //               alt={`vehicle-${index}`}
    //               style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 4 }}
    //             />
    //           ) : (
    //             <div>NA</div>
    //           )}
    //         </div>
    //       ))}
    //     </div>
    //   ),
    // },

    {
      header: "Make",
      id: "make",
      filterVariant: "text",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: (row) => (
        <div>
          {row.row.original.user_vehicle.map((vehicle, index) => (
            <AutoTooltip maxWidth={100}>
              <div key={index}>{vehicle.make || "-"}</div>
            </AutoTooltip>
          ))}
        </div>
      ),
    },
    {
      header: "Model",
      id: "model",
      filterVariant: "text",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: (row) => (
        <div>
          {row.row.original.user_vehicle.map((vehicle, index) => (
            <AutoTooltip maxWidth={100}>
              <div key={index}>{vehicle.model || "-"}</div>
            </AutoTooltip>
          ))}
        </div>
      ),
    },
    {
      header: "Variant",
      id: "variant",
      filterVariant: "text",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: (row) => (
        <div>
          {row.row.original.user_vehicle.map((vehicle, index) => (
            <AutoTooltip maxWidth={150}>
              <div key={index}>{vehicle.variant || "-"}</div>
            </AutoTooltip>
          ))}
        </div>
      ),
    },

    {
      header: "Action",
      accessorKey: "action",
      enableColumnFilter: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      align: "center",
      Cell: ({ row }) => {
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        const handleClick = (event) => setAnchorEl(event.currentTarget);
        const handleClose = () => setAnchorEl(null);

        const handleAction = (action) => {
          action();
          handleClose();
        };
        const isActive = row.original.status?.toLowerCase() === "active";


        return (
          <div>

            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? "long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>

            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() =>
                  handleAction(() => handleViewDriver(row?.original))
                }
              >
                <ListItemIcon>
                  <LaunchIcon fontSize="small" />
                </ListItemIcon>
                <Typography variant="inherit" sx={{ color: "#202020" }}>
                  View Driver
                </Typography>
              </MenuItem>

              <Divider />

              <MenuItem
                onClick={() =>
                  handleAction(() => handleAssignDriver(row?.original))
                }
              >
                <ListItemIcon
                  sx={{
                    "& img": {
                      width: 20,
                      height: 20,
                      filter: "brightness(0) invert(0.6)",
                    },
                  }}
                >
                  <img src={Assign_driver_url} alt="Assign Vehicle" />
                </ListItemIcon>
                <Typography variant="inherit" sx={{ color: "#202020" }}>
                  Assign Vehicle
                </Typography>
              </MenuItem>

              <Divider />

              <MenuItem
                onClick={() => handleAction(() => handleEdit(row?.original))}
              >
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <Typography variant="inherit" sx={{ color: "#202020" }}>
                  Edit Driver
                </Typography>
              </MenuItem>

              <Divider />

              <MenuItem
                onClick={() => handleAction(() => ResetPassword(row?.original))}
              >
                <ListItemIcon
                  sx={{
                    "& img": {
                      width: 20,
                      height: 20,
                      filter: "brightness(0) invert(0.6)",
                    },
                  }}
                >
                  <img src={Reset_pass_icon} alt="Reset Password" />
                </ListItemIcon>
                <Typography variant="inherit" sx={{ color: "#202020" }}>
                  Reset Password
                </Typography>
              </MenuItem>

              <Divider />


              <MenuItem
                onClick={() =>
                  handleAction(() => handleToggleDriverStatus(row.original))
                }
              >
                <ListItemIcon
                  sx={{
                    minWidth: 28,
                    color: isActive ? "#DC2626" : "#22C55E",
                  }}
                >
                  {isActive ? (
                    <BlockIcon fontSize="small" />
                  ) : (
                    <CheckCircleIcon fontSize="small" />
                  )}
                </ListItemIcon>

                <Typography
                  variant="inherit"
                  sx={{ color: isActive ? "error.main" : "success.main" }}
                >
                  {isActive ? "Inactivate Driver" : "Activate Driver"}
                </Typography>
              </MenuItem>

            </Menu>
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    setColumns(column);
  }, [sidenavColor]);

  const navigate = useNavigate();
  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
  }, []);

  const handleStateChange = (newState) => {
    setIsDisabled(newState);
  };

  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  return (
    <DashboardLayout>
      <MDBox></MDBox>

      <PopAddUser
        isDialog={isDisabled}
        onClose={setIsDisabled}
        value={values}
        onStateChange={handleStateChange}
        onHandleChange={handleChange}
      />
      <BulkUploadDialog
        open={bulkUploadOpen}
        onClose={() => setBulkUploadOpen(false)}
        moduleName="driver"
        onUploadSuccess={() => {
          fetchFullDriverList();
        }}
      />
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon="group"
                title="Total Drivers"
                count={totalDriversCount}
                isClickable={false}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="person"
                title="Active Drivers"
                count={activeDrivers}
                percentage={{
                  color: "success",
                  amount: `${totalDriversCount ? Math.floor((activeDrivers / totalDriversCount) * 100) : 0}%`,
                  label: "of total",
                }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="person_off"
                title="Inactive Drivers"
                count={inactiveDrivers}
                percentage={{
                  color: "error",
                  amount: `${totalDriversCount ? Math.floor((inactiveDrivers / totalDriversCount) * 100) : 0}%`,
                  label: "of total",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>

        <MDBox mt={8}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={1.5}
              px={2}
              variant="gradient"
              bgColor={sidenavColor}
              borderRadius="lg"
              coloredShadow="info"
            >
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  All Drivers
                </MDTypography>
                <MDBox display="flex" gap={1}>
                  <MDButton
                    onClick={() => handleDownloadDriversExcel()}
                    variant="outlined"
                    color="white"
                    size="small"
                    startIcon={<GetAppIcon />}
                  >
                    Export Drivers
                  </MDButton>
                  <MDButton
                    onClick={() => setBulkUploadOpen(true)}
                    variant="outlined"
                    color="white"
                    size="small"
                    startIcon={<UploadFileIcon />}
                  >
                    Bulk Upload
                  </MDButton>
                  <MDButton
                    onClick={() => setIsDisabled(!isDisabled)}
                    variant="outlined"
                    color="white"
                    size="small"
                  >
                    Add Driver
                  </MDButton>
                </MDBox>
              </Grid>
            </MDBox>
            {isLoading ? (
              <Loader />
            ) : (
              // <CustomMaterialTable
              //   columns={columns}
              //   data={dataRec}
              //   manualPagination={true}
              //   rowCount={totalRows}
              //   onPaginationChange={(newPage) => setPagination(newPage)}
              //   page={page}
              //   pageSize={pageSize}
              //   setPagination={pagination}
              //   muiSearchTextFieldProps={{
              //     placeholder: "Search by name, email, etc.",
              //     value: searchText,
              //     onChange: (event) => handleSearchChange(event.target.value),
              //   }}
              //   defaultColumn={{
              //     minSize: 100,     
              //     size: 140,        
              //     maxSize: 400,
              //   }}  
              //   onSortingChange={handleSortingChange}
              //   initialState={{
              //     columnVisibility: {
              //       make: false,
              //       model: false,
              //       gender: false,
              //       dob: false,
              //       role: false,
              //       email: false,
              //       battery_capacity: false,
              //       type: false,
              //       variant: false,
              //       vehicle_img: false,
              //     },
              //   }}
              //   manualSorting
              //   enableSorting
              //   muiTablePaginationProps={{
              //     rowsPerPageOptions: [5, 10, 20, 50],
              //     showFirstButton: true,
              //     showLastButton: true,
              //     count: totalRows,
              //     page: page,
              //     rowsPerPage: pageSize,
              //   }}
              //   muiTableProps={{
              //     sx: darkMode
              //       ? {
              //         backgroundColor: "#202940",
              //         color: "#ffffff",
              //         "& td": {
              //           fontSize: "14px",
              //           fontWeight: "500",
              //           color: "#ffffff",
              //           padding: 0,
              //         },
              //       }
              //       : {
              //         "& td": {
              //           fontSize: "14px",
              //           fontWeight: "500",
              //           padding: 0,
              //           backgroundColor: "#f5f5f5",
              //         },
              //       },
              //   }}
              //   muiTopToolbarProps={{
              //     sx: darkMode
              //       ? {
              //         color: "#ffffff",
              //         "& svg": {
              //           fontSize: "14px",
              //           fontWeight: "500",
              //           color: "#ffffff",
              //           padding: 0,
              //         },
              //       }
              //       : {
              //         backgroundColor: "#f5f5f5",
              //       },
              //   }}
              //   muiTableHeadCellProps={{
              //     sx: darkMode
              //       ? {
              //         color: "#ffffff",
              //         "& svg": {
              //           fontSize: "14px",
              //           fontWeight: "500",
              //           color: "#ffffff",
              //           padding: 0,
              //         },
              //       }
              //       : {
              //         backgroundColor: "#f5f5f5",
              //       },
              //   }}
              //   muiBottomToolbarProps={{
              //     sx: darkMode
              //       ? {
              //         color: "#ffffff",
              //         "& p,button,div": {
              //           fontWeight: "500",
              //           color: "#ffffff",
              //           padding: 0,
              //         },
              //       }
              //       : {
              //         backgroundColor: "#f5f5f5",
              //       },
              //   }}
              //   muiTableBodyCellProps={{
              //     sx: {
              //       borderBottom: "2px solid #e0e0e0",
              //     },
              //   }}
              // />
              <CustomMaterialTablePage
                columns={columns}
                data={dataRec}
                darkMode={darkMode}
                manualPagination={true}
                manualFiltering={false}
                rowCount={totalRows}
                paginationChange={(newPage) => setPagination(newPage)}
                initialState={{
                  columnVisibility: {
                    claimed_range: false,
                    connector_type: false,
                  },
                }}
                soringChange={handleSortingChange}
                page={page}
                pagesize={pageSize}
                paginataion={pagination}
                sorting={sorting}
                searchChange={handleSearchChange}
                onColumnFiltersChange={setColumnFilters}
                onColumnVisibilityChange={setColumnVisibility}
                state={{
                  pagination,
                  sorting,

                  columnFilters,
                  columnVisibility,
                }}
                globalFilterDebounceMs={2000}
              />
            )}
          </Card>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Driver_mgmt;
